<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-one-quarter">
          <div class="panel">
            <p class="panel-heading">
              Search for Events
            </p>
            <div class="panel-block">
              <p class="control has-icons-left">
                <input class="input" type="text" placeholder="search">
                <span class="icon is-left">
                  <i class="fas fa-search" aria-hidden="true"></i>
                </span>
              </p>
            </div>
            <label class="panel-block">
              Start
              <input type="datetime-local">
            </label>
            <label class="panel-block">
              <input type="checkbox">
              remember me
            </label>
            <div class="panel-block">
              <button class="button is-link is-outlined is-fullwidth">
                reset all filters
              </button>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle">
                  <strong>123</strong> events
                </p>
              </div>
            </div>
            <div class="level-right">
              <p class="level-item">
                <a class="pagination-previous" disabled>Previous</a>
                <a class="pagination-previous">Next</a>
              </p>
            </div>
          </div>
            <div class="card" v-for="n in 10" v-bind:key="n">
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4">{{n}} John Smith</p>
                    <p class="subtitle is-6">@johnsmith</p>
                  </div>
                </div>

                <div class="content">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Phasellus nec iaculis mauris. <a>@bulmaio</a>.
                  <a href="#">#css</a> <a href="#">#responsive</a>
                  <br>
                  <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
                </div>
              </div>
            </div>
          <nav class="pagination" role="navigation" aria-label="pagination">
            <a class="pagination-previous" disabled>Previous</a>
            <a class="pagination-next">Next</a>
            <ul class="pagination-list">
              <li>
                <a class="pagination-link" aria-label="Goto page 1">1</a>
              </li>
              <li>
                <span class="pagination-ellipsis">&hellip;</span>
              </li>
              <li>
                <a class="pagination-link" aria-label="Goto page 45">45</a>
              </li>
              <li>
                <a class="pagination-link is-current" aria-label="Page 46" aria-current="page">46</a>
              </li>
              <li>
                <a class="pagination-link" aria-label="Goto page 47">47</a>
              </li>
              <li>
                <span class="pagination-ellipsis">&hellip;</span>
              </li>
              <li>
                <a class="pagination-link" aria-label="Goto page 86">86</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: 'SearchEvents',
  props: ['userInfo'],
}
</script>